import axios from "axios";
import { getAuthToken } from "./firebase";

const { REACT_APP_ORACLE_ENV } = process.env;

const defaultApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  transformResponse: axios.defaults.transformResponse.concat(
    (params) => params.data || params
  ),
  withCredentials: REACT_APP_ORACLE_ENV,
});

const headers = REACT_APP_ORACLE_ENV
  ? {}
  : { authorization: await getAuthToken() };

export const getUserData = async (userId) => {
  return await defaultApi.get(`/users/${userId}`, { headers });
};

// ! depotCodeList is here just so this can work with the Oracle Volume Sim API, so I don't have to keep maintaining two separate APIs that are basically the same
export const simulateData = async (depotCode, volumeDate, percentage) => {
  return await defaultApi.post(
    `/simulate`,
    {
      depotCodeList: [depotCode],
      volumeDate,
      percentage,
    },
    { headers }
  );
};

export const getBoundariesAndActiveOverlayDates = async (depotCode) => {
  return await defaultApi.get(`/postcode/boundaries`, {
    params: { depotCodeList: [depotCode] },
    headers,
  });
};

export const getAllDepotsWithMapboxBoundaries = async () => {
  return await defaultApi.get(`/postcode/depots`, {
    headers,
  });
};

export const getParcelDataForFullMap = async (overlayDate) => {
  return await defaultApi.get(`/postcode/${overlayDate}/depots`, {
    params: { overlayDate },
    headers,
  });
};

export default defaultApi;
